export const FORMATE = [
    { id: 'vertical', label: 'Hochkant 9:16', hint: 'Reels, Stories', kurz: '9:16', width: 1080, height: 1920 },
    { id: 'horizontal', label: 'Quer 16:9', hint: 'Website, YouTube', kurz: '16:9', width: 1920, height: 1080 },
    { id: 'square', label: 'Quadratisch 1:1', hint: 'Feed', kurz: '1:1', width: 1080, height: 1080 },
    { id: 'vertical45', label: 'Hochkant 4:5', hint: 'Instagram-Beitrag', kurz: '4:5', width: 1080, height: 1350 },
];
/**
 * Das Kurzzeichen für ein Mass: das des Formats mit demselben Verhältnis
 * (720×1280 ist auch 9:16), sonst Breite×Höhe.
 */
export function formatKurz(width, height) {
    if (!(width > 0) || !(height > 0))
        return '?';
    const v = width / height;
    const treffer = FORMATE.find((f) => Math.abs(f.width / f.height - v) < 0.005);
    return treffer ? treffer.kurz : `${Math.round(width)}×${Math.round(height)}`;
}
/** Das Format zu einem Mass -- oder null, wenn es ein eigenes ist. */
export function formatVon(width, height) {
    if (!(width > 0) || !(height > 0))
        return null;
    const v = width / height;
    return FORMATE.find((f) => Math.abs(f.width / f.height - v) < 0.005) ?? null;
}
//# sourceMappingURL=formate.js.map